// extracted by mini-css-extract-plugin
export default {"rules_container":"Rules_rules_container__xg+TB","rules_content":"Rules_rules_content__+8q5t"};